import Icon from "@material-ui/icons/SyncDisabled";
import DueRenewalStudentList from "./CcaDueRenewalStudentList";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "ccaStudentRenewals",
  list: DueRenewalStudentList,
  icon: Icon,
};
